export function queryParamForward() {
    let query_str =  new URL(window.location.href);
    query_str = query_str.search.substring(1);

    let paramsForward = document.querySelector('#queryParamsForward');
    const prodUrlForward = document.querySelector('#prodUrlForward');
    const devUrlForward = document.querySelector('#devUrlForward');
    let itemsAppendQryParams = document.querySelector('#itemsAppendQryParams');

    if (!paramsForward && !prodUrlForward && !devUrlForward && !itemsAppendQryParams) {
        return;
    }
    
    paramsForward = paramsForward.value.trim();
    const params = new URLSearchParams(query_str);
    const pocessedParams = paramsForward.split(',').map(param => param.trim());

    const queryString = pocessedParams
        .map(param => params.has(param) ? `${param}=${params.get(param)}` : '')
        .filter(param => param !== '')
        .join('&');

    try {
        itemsAppendQryParams = JSON.parse(itemsAppendQryParams.value.trim());
    } catch (error) {
        console.error(error);
        return;
    }

    const originationsURL = (window.location.origin === 'https://oportun.com' ? prodUrlForward.value.trim() + '?' : devUrlForward.value.trim() + '?');


    itemsAppendQryParams.forEach(element => {
        document.querySelectorAll(element.item_selector).forEach(button => {
            const buttonText = button.innerText.toLowerCase();
            const validText = element.item_selector_text.split(',');

            if (validText.some(text => buttonText.includes(text.toLowerCase()))) {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    window.location = originationsURL + queryString;
                });
                button.addEventListener('contextmenu', () => {
                    button.href = originationsURL + queryString;
                });
            }
        });
    });
}

export function queryParamForwardleadId() {
    // Get query string from current URL
    let query_str =  new URL(window.location.href);
    query_str = query_str.search.substring(1);

    let queryGlobalParamsForward = document.querySelector('#queryGlobalParamsForward');

    let queryParamLang = '';
    if (window.location.href.indexOf("/es/") > -1) {
       queryParamLang = '&lang=es';
    } else {
        queryParamLang = '&lang=en';
    }
    if(!queryGlobalParamsForward){
        return;
    }

    queryGlobalParamsForward = queryGlobalParamsForward.value.trim();
    const params = new URLSearchParams(query_str);
    if (!params.has('leadId') && !/\/info\//.test(window.location.pathname)) {
        return;
    }

    // Get leadId from query string
    const leadId = params.get('leadId');

    const marketing_source = sessionStorage.getItem("marketing_source");
    if (!/leadId:[0-9]{15}/.test(marketing_source)){
        sessionStorage.setItem("leadId", marketing_source + leadId);
        sessionStorage.setItem("leadId", leadId );
    } else{
        sessionStorage.setItem("leadId", leadId );
    }

    const processedParams = queryGlobalParamsForward.split(',').map(param => param.trim());
    const queryString = processedParams
        .map(param => params.has(param) ? `${param}=${params.get(param)}` : '')
        .filter(param => param !== '')
        .join('&');

    // Helper function to append leadId to a URL, handling first or subsequent query string
    function appendLeadId(url) {
        if (!url) return url;
        const hasQuery = url.includes('?');
        const leadIdParam = `leadId=${leadId.replace(/[^0-9]/g, '')}`;
        // Avoid duplicate leadId parameter
        if (url.includes('leadId=')) return url;
        return url + (hasQuery ? '&' : '?') + leadIdParam;
    }

    // Modify the CTA from the navbar based on the browser width, using the existing href
    const browserWidth = window.innerWidth;
    if (browserWidth < 768) {
        const cta = document.querySelector('div.ctamobile a.cta-mobile.button');
        if (cta) cta.href = appendLeadId(cta.href);
    } else {
        const component = document.querySelector('oportun-apply-button');
        if (!component) return null;

        const slot = component.shadowRoot.querySelector('slot');
        const assigned = slot.assignedElements();
        const anchor = assigned.find(el => el.tagName === 'A');
        if (anchor) {
            anchor.href = appendLeadId(anchor.href);
        }
    }
    // Update all "Apply Now" buttons with leadId, using their existing href
    const applyNowButtons = document.querySelectorAll('a.button, a.btn');
    applyNowButtons.forEach(button => {
        const href = button.getAttribute('href');
        if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
            button.href = appendLeadId(href);
        }
    });

    // Update links inside shadow DOM components with leadId, using their existing href
    const shadowHosts = Array.from(document.querySelectorAll('oportun-slider, oportun-list'));
    for (const host of shadowHosts) {
        // Find all oportun-list-item elements inside shadow DOM
        const listItems = Array.from(host.shadowRoot.querySelectorAll('oportun-list-item'));
        for (const listItem of listItems) {
            // Find all <a> elements within each list item
            const links = Array.from(listItem.querySelectorAll('a'));
            links.forEach(link => {
                const href = link.getAttribute('href');
                // Only update URLs matching apply/aplica.oportun.com
                if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
                    link.href = appendLeadId(href);
                }
            });
        }
    }
}

export function handleQueryParams() {
    // verify the elements needed to execute queryParamForward
    const paramsForward = document.querySelector('#queryParamsForward');
    const prodUrlForward = document.querySelector('#prodUrlForward');
    const devUrlForward = document.querySelector('#devUrlForward');
    const itemsAppendQryParams = document.querySelector('#itemsAppendQryParams');

    if (paramsForward && prodUrlForward && devUrlForward && itemsAppendQryParams) {
        queryParamForward();
        return;
    }

    // verify the elements needed to execute queryParamForwardleadId
    const queryGlobalParamsForward = document.querySelector('#queryGlobalParamsForward');

    if (queryGlobalParamsForward) {
        queryParamForwardleadId();
        return;
    }

}

export function queryParamSessionStorageLeadId() {
    let leadId = sessionStorage.getItem("leadId");
    if (leadId === null) {
        return;
    }

    // Helper function to append leadId to a URL, handling first or subsequent query string
    function appendLeadId(url) {
        if (!url) return url;
        const hasQuery = url.includes('?');
        const leadIdParam = `leadId=${leadId.replace(/[^0-9]/g, '')}`;
        // Avoid duplicate leadId parameter
        if (url.includes('leadId=')) return url;
        return url + (hasQuery ? '&' : '?') + leadIdParam;
    }

    // Modify CTA in navbar based on browser width
    const browserWidth = window.innerWidth;
    if (browserWidth < 768) {
        const cta = document.querySelector('div.ctamobile a.cta-mobile.button');
        if (cta) cta.href = appendLeadId(cta.href);
    } else {
        const component = document.querySelector('oportun-apply-button');
        if (!component) return null;
        const slot = component.shadowRoot.querySelector('slot');
        const assigned = slot.assignedElements();
        const anchor = assigned.find(el => el.tagName === 'A');
        if (anchor) {
            anchor.href = appendLeadId(anchor.href);
        }
    }

    // Update all "Apply Now" buttons with leadId
    const applyNowButtons = document.querySelectorAll('a.button, a.btn');
    applyNowButtons.forEach(button => {
        const href = button.getAttribute('href');
        // Only update URLs matching apply/aplica.oportun.com
        if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
            button.href = appendLeadId(href);
        }
    });

    // Update links inside shadow DOM components with leadId
    const shadowHosts = Array.from(document.querySelectorAll('oportun-slider, oportun-list'));
    for (const host of shadowHosts) {
        // Find all oportun-list-item elements inside shadow DOM
        const listItems = Array.from(host.shadowRoot.querySelectorAll('oportun-list-item'));
        for (const listItem of listItems) {
            // Find all <a> elements within each list item
            const links = Array.from(listItem.querySelectorAll('a'));
            links.forEach(link => {
                const href = link.getAttribute('href');
                // Only update URLs matching apply/aplica.oportun.com
                if (href && /https:\/\/(apply|aplica)\.oportun\.com(\/.*)?/.test(href)) {
                    link.href = appendLeadId(href);
                }
            });
        }
    }
}